import { parsePhoneNumber, PhoneNumber } from 'libphonenumber-js'
import { Country, toCountry } from '@/app/country'
import { CountryConfig } from '@/types/countryConfig'

// Country config fields that give the hotline phone
type HotlineConfig = Pick<CountryConfig, 'countryCode' | 'phone'>

// Phone of the SeDomicilier hotline in each country, until the country config is read
const DEFAULT_PHONE_BY_COUNTRY: Record<Country, string> = {
  FR: '+33183643107',
  BE: '+3228973469'
}

// Phone of the hotline read in the country config, else the default phone of its country or of the domain country
const parsedHotlinePhone = (
  countryConfig: HotlineConfig | undefined,
  fallbackCountry: Country
): PhoneNumber => {
  const country = toCountry(countryConfig?.countryCode) ?? fallbackCountry
  try {
    return parsePhoneNumber(countryConfig?.phone ?? '')
  } catch {
    return parsePhoneNumber(DEFAULT_PHONE_BY_COUNTRY[country])
  }
}

// Link and displayed number of the hotline phone: national format in French, international format otherwise
export const hotlinePhone = (
  countryConfig: HotlineConfig | undefined,
  fallbackCountry: Country,
  locale: string
) => {
  const phone = parsedHotlinePhone(countryConfig, fallbackCountry)
  return {
    href: phone.getURI(),
    label: locale.startsWith('fr')
      ? phone.formatNational()
      : phone.formatInternational()
  }
}
